export const fields = [
	{
		label: 'Text Field',
		id: '',
		type: 'input',
		inputStyle: 'text',
		control: 'text',
		name: 'text',
		icon: 'assets/icons/form-fields/text.svg',
		title: 'Free text response'
	},

	{
		label: 'Number',
		id: '',
		name: 'integer',
		type: 'input',
		inputStyle: 'integer',
		control: 'number',
		icon: 'assets/icons/form-fields/number.svg',
		title: 'Integer (i.e., whole number) input'
	},
	{
		label: 'Date',
		id: '',
		name: 'date',
		type: 'input',
		inputStyle: 'date',
		control: 'date',
		icon: 'assets/icons/form-fields/date_time.svg',
		title: 'Accepts a date  input'
	},
	{
		label: 'Date/Time',
		id: '',
		name: 'dateTime',
		type: 'input',
		inputStyle: 'dateTime',
		control: 'date',
		icon: 'assets/icons/form-fields/date_time.svg',
		title: 'Accepts a date and a time input'
	},
	{
		label: 'Select One',
		id: '',
		name: 'select_one',
		type: 'select',
		inputStyle: 'select_one',
		control: 'input',
		icon: 'assets/icons/form-fields/select_list.svg',
		title: '	Multiple choice question; only one answer can be selected'
	},
	{
		label: 'Select Multiple',
		id: '',
		name: 'select_multiple',
		inputStyle: 'select_multiple',
		type: 'select',
		control: 'input',
		icon: 'assets/icons/form-fields/multi_select.svg',
		title: 'Multiple choice question; multiple answers can be selected'
	},

	{
		label: 'File Upload',
		id: '',
		name: 'file',
		inputStyle: 'file',
		type: 'file',
		control: 'file',
		icon: 'assets/icons/form-fields/upload.svg',
		title: 'Scan a barcode'
	},
	{
		label: 'Location',
		id: '',
		name: 'geopoint',
		inputStyle: 'geopoint',
		type: 'input',
		control: 'text',
		icon: 'assets/icons/form-fields/location.svg',
		title: 'Collect a single GPS coordinates'
	},
	// {
	// 	label: "Checkboxes",
	// 	id: "",
	// 	type: "checkbox",
	// 	inputStyle: "text",
	// 	control: "checkbox",
	// 	name: "text",
	// 	icon: "assets/icons/form-fields/checkbox.svg",
	// 	title: "Free text response",
	// },
	// {
	// 	label: "Radio",
	// 	id: "",
	// 	type: "radio",
	// 	inputStyle: "text",
	// 	control: "radio",
	// 	name: "text",
	// 	icon: "assets/icons/form-fields/radio.svg",
	// 	title: "Free text response",
	// },
	{
		label: 'Paragraph',
		id: '',
		name: 'paragraph',
		inputStyle: 'paragraph',
		type: 'textarea',
		control: 'text',
		icon: 'assets/icons/form-fields/textarea.svg',
		title: 'Acknowledge prompt that sets value to “OK” if selected'
	}
];
